export default __webpack_public_path__ + "static/team-76f067088479946a9fff1725b702f84f.jpg";